// extracted by mini-css-extract-plugin
export default {"select":"Merge_select__dBl4m"};